import { Header } from '../components/layout/Header';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';

/**
 * Admin settings page.
 * Platform configuration and preferences.
 */
export function SettingsPage() {
  return (
    <>
      <Header title="Settings" description="Platform configuration" />

      <div className="p-6 max-w-3xl">
        {/* General Settings */}
        <Card padding="md" hover={false} className="mb-6">
          <h2 className="text-card-title text-text mb-4">
            General Settings
          </h2>
          <p className="text-body-sm text-text-secondary">
            Platform-wide settings will be available here in a future update.
          </p>
        </Card>

        {/* Notification Settings */}
        <Card padding="md" hover={false} className="mb-6">
          <h2 className="text-card-title text-text mb-4">
            Notifications
          </h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-body font-medium text-text">
                  Email Alerts
                </p>
                <p className="text-body-sm text-text-secondary">
                  Receive email notifications for critical events
                </p>
              </div>
              <Button variant="secondary" size="sm" disabled>
                Configure
              </Button>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-body font-medium text-text">
                  Slack Integration
                </p>
                <p className="text-body-sm text-text-secondary">
                  Send alerts to a Slack channel
                </p>
              </div>
              <Button variant="secondary" size="sm" disabled>
                Connect
              </Button>
            </div>
          </div>
        </Card>

        {/* API Settings */}
        <Card padding="md" hover={false}>
          <h2 className="text-card-title text-text mb-4">
            API Configuration
          </h2>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-body font-medium text-text">
                  Rate Limits
                </p>
                <p className="text-body-sm text-text-secondary">
                  Configure API rate limiting thresholds
                </p>
              </div>
              <Button variant="secondary" size="sm" disabled>
                Configure
              </Button>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-body font-medium text-text">
                  Webhooks
                </p>
                <p className="text-body-sm text-text-secondary">
                  Manage outgoing webhook endpoints
                </p>
              </div>
              <Button variant="secondary" size="sm" disabled>
                Manage
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
